import React from 'react';
import {Link} from "react-router-dom";

class ListItem extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {data, hasAngle} = this.props;

        return (
            <div className="list-group list-custom-small">
                {data && data.length > 0 &&
                data.map(item => {
                    const {title, number, icon, onClick, component} = item;

                    return (
                        <a onClick={onClick} className='list-item-style'>
                            {number &&
                            <i className='rounded-sm shadow-xl bg-primary' style={{fontStyle: 'normal'}}>
                                {number}
                            </i>
                            }
                            {icon &&
                            <i className='rounded-sm shadow-xl bg-primary' style={{fontStyle: 'normal', marginTop: 0}}>
                                <p className={`fa fa-${icon}`} style={{fontSize: 13, color: 'black'}}></p>
                            </i>
                            }
                            {component ? component() :
                                <span className='float-right' style={{fontSize: 13}}>
                                    {title}
                                </span>
                            }
                            {hasAngle &&
                            <i className="fa fa-angle-left"></i>
                            }
                        </a>
                    );
                })
                }
            </div>
        );
    }
}

export default ListItem;
